import LabelInput from './LabelInput';
import LabelOption from './LabelOption';
import LabelSwitch from './LabelSwitch';
import LabelColor from './LabelColor';

export default {
    components: {
        LabelInput,
        LabelOption,
        LabelSwitch,
        LabelColor
    },
    props: ['tag', 'attrs', 'param', 'disabled'],
    model: {
        prop: 'param',
        event: 'change'
    },
    render() {
        return this.$createElement(this.tag, {
            attrs: { ...this.attrs, disabled: this.disabled },
            model: {
                value: this.param,
                callback: (e) => {
                    this.$emit('change', e);
                },
                expression: 'param'
            }
        });
    }
};
